import React, { useState } from 'react'
import { HTTP } from '../../api/resources'

export default function Index({emailRecord}) {
    const [emailDomain, setEmailDomain] = useState(emailRecord)
    const [saving, setSaving] = useState(false)
    const [validating, setValidating] = useState(false)

    const addEmail = async () => {
        if (!emailDomain.email_domain) return
        if (!validation()) return
        setSaving(true)

        try {
            await createRequest()
            Alert.show('notice', 'Email domain added successfully')
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        } catch (error) {
            Alert.show('error', 'An error occurred, please try again')
            setSaving(false)
        }
    }

    const createRequest = () => {
        return HTTP.post('/email_authentication', emailDomain)
    }

    const validation = () => {
        if (emailDomain.email_domain && emailDomain.email_domain.includes(' ')) {
          Alert.show('notice', 'Custom domain cannot include spaces')
          return false
        }
    
        if (emailDomain.email_domain && (emailDomain.email_domain.includes('http:') || emailDomain.email_domain.includes('https:'))) {
          Alert.show('notice', 'No protocol needed, just enter the domain e.g subdomain.domain.com')
          return false
        }
    
        let regex = /^([a-zA-Z0-9-]+)\.([a-zA-Z0-9-]+\.[a-zA-Z]{2,})$/
        if (emailDomain.email_domain && !regex.test(emailDomain.email_domain)) {
          Alert.show('notice', 'A subdomain is required e.g subdomain.domain.com')
          return false
        }
    
        if (emailDomain.email_domain && emailDomain.email_domain.toLowerCase().includes('giveclarity.co')) {
          Alert.show('notice', 'You cannot use giveclarity.co as your custom domain')
          return false
        }

        if (!emailDomain.sending_email) {
            Alert.show('notice', 'Sending email is required')
            return false
        }

        let domainArray = emailDomain.email_domain.split('.')
        let domain = domainArray[domainArray.length - 2] + '.' + domainArray[domainArray.length - 1]
        if (emailDomain.sending_email && !emailDomain.sending_email.includes(domain)) {
            Alert.show('notice', 'Sending email must be from the same domain as the email domain')
            return false
        }
    
        return true
    }

    const validateEmailAuthentication = async () => {
        setValidating(true)

        try {
            let response = await HTTP.post(`/email_authentication/validate`)
            Alert.show('notice', response.data.body)
            setTimeout(() => {
                window.location.reload()
            }, 5000);
        } catch (error) {
            Alert.show('error', 'An error occurred, please try again')
            setValidating(false)
        }
    }


  return (
    <div>
        <div className="page-header header-flex">
            <h4 className="page-title">
                Email Authentication
            </h4>
        </div>

        <div className='card'>
            <div className="card-header flex-header">
                <h4 className="card-title">
                    Email Record
                </h4>

                <div>
                    <div className="btn-group">
                        <button
                            onClick={addEmail}
                            name="button"
                            className="btn btn-primary"
                            type="button"
                            disabled={saving || validating || emailRecord.email_domain}
                        >
                            {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Save
                        </button>
                    </div>
                </div>
            </div>

            <div classNamw="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="title">Email Domain</label>
                            <input 
                                className="form-control"
                                placeholder="subdomain.domain.com" 
                                type="text" 
                                name="title" 
                                id="title" 
                                value={emailDomain.email_domain} 
                                onChange={(event) => setEmailDomain({...emailDomain, email_domain: event.target.value})}
                                disabled={emailRecord.email_domain}
                            />
                            <small>Make sure this domain belongs to you and you can edit the DNS records </small>
                        </div>
                        
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="sending_email">Sending Email</label>
                            <input 
                                className="form-control"
                                placeholder="example@domain.com" 
                                type="email" 
                                name="sending_email" 
                                id="sending_email" 
                                value={emailDomain.sending_email} 
                                onChange={(event) => setEmailDomain({...emailDomain, sending_email: event.target.value})}
                                disabled={emailRecord.email_domain}
                            />
                            <small>Make sure the email provided uses the same domain as the Email Domain</small>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <div className='card'>
            <div className='card-header flex-header'>
                <h4 className='card-title'>
                    DNS Records 
                </h4>

                <div>
                    <div className='btn-group'>
                        <button 
                            className='btn btn-primary'
                            type='button'
                            name='button'
                            disabled={!emailRecord.email_domain || !emailRecord.dns_record || saving || validating || emailRecord.validated}
                            onClick={validateEmailAuthentication}
                        >
                            {validating && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Validate Email
                        </button>
                    </div>
                </div>
            </div>
            <div className='card-body'>
                <div>
                    <table className="in-show-tb mt-3">
                        <tr>
                            <th className="col-md-2 t-header-one">Type</th>
                            <th className="col-md-4 t-header-tw">Host</th>
                            <th className="col-md-4 t-header-tw">Data</th>
                            <th className="col-md-2 t-header-tw">Status</th>
                        </tr>
                        {emailRecord.dns_record && emailRecord.dns_record.map((record, index) => (
                            <tr key={index}>
                                <td className="col-md-2 t-header-one">{record[1].type.toUpperCase()}</td>
                                <td className="col-md-4 t-header-tw">{record[1].host}</td>
                                <td className="col-md-4 t-header-tw">{record[1].data}</td>
                                <td className="col-md-2 t-header-tw">{record[1].valid ? 'Verified' : 'Pending'}</td>
                            </tr>
                        ))}
                    </table>
                </div>
                <div className='form-group'>
                    <small>
                        These are the DNS records you need to add to your DNS provider to verify your domain, 
                        after 24 hours of adding the records fo your DNS provider, click the validate button. 
                        Once all records are verified, emails will be automatically sent with your domain.
                    </small>
                </div>
            </div>
        </div>
    </div>
  )
}
